import React, { useState, useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  FaBuilding,
  FaInstagram,
  FaFacebookSquare,
  FaRobot,
  FaPenSquare,
  FaWindowMaximize,
  FaTimes,
  FaWhatsapp,
  FaEnvelope,
  FaPhoneVolume,
  FaWeebly,
  FaRocketchat,
} from 'react-icons/fa';
import { IoMdMail } from 'react-icons/io';
import api from '~/services/api';
import history from '~/services/history';
// Importando os componentes
import Card from '~/components/Card';
import Load from '~/components/Load';

import {
  Container,
  InfoAtendimento,
  TarefaDia,
  InfoTarefas,
  Info,
  Tarefas,
  Dia,
  Blocos,
  Bloco,
  BlocosDia,
  DadosPessoais,
  Dados,
  InfoTentativas,
  DadosAtendimento,
  Atrasadas,
  Atendimento,
  BtCarregar,
} from './styles';

export default function NovoAtendimento() {
  // Selector redux
  const [dadosAtrasados, setDadosAtrasados] = useState([]);
  const [dadosAndamento, setDadosAndamento] = useState([]);
  const [carregarVisible, setCarregarVisible] = useState(false);
  const [carregarVisibleAtrasado, setCarregarVisibleAtrasado] = useState(false);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pageAtrasado, setPageAtrasado] = useState(1);

  // Info
  const [countEmail, setCountEmail] = useState(0);
  const [countTelefone, setCountTelefone] = useState(0);
  const [countWhatsapp, setCountWhatsapp] = useState(0);
  const [countAtrasados, setCountAtrasados] = useState(0);

  const getDados = useCallback(async () => {
    const responseListagem = await api.get('/atividade-realizar');

    setDadosAndamento(responseListagem.data.data);
    const totalAndamento = Number(responseListagem.data.total);

    if (responseListagem.data.data.length >= totalAndamento) {
      setCarregarVisible(false);
    } else {
      setCarregarVisible(true);
    }
  }, []);

  const getAtrasados = useCallback(async () => {
    const responseAtrasado = await api.get('/atividade-atrasado');
    const totalAtrasado = Number(responseAtrasado.data.total);

    if (responseAtrasado.data.data.length >= totalAtrasado) {
      setCarregarVisibleAtrasado(false);
    } else {
      setCarregarVisibleAtrasado(true);
    }

    setDadosAtrasados(responseAtrasado.data.data);
  }, []);

  const getContagem = useCallback(async () => {
    // Fazendo a contagem
    const responseDadosAndamento = await api.get('/atividade-countL');
    const responseDadosAtrasado = await api.get('/atividade-countD');

    setCountTelefone(responseDadosAndamento.data.telefone);
    setCountEmail(responseDadosAndamento.data.email);
    setCountWhatsapp(responseDadosAndamento.data.whatsapp);
    setCountAtrasados(responseDadosAtrasado.data);
    setLoading(false);
  }, []);

  // testando redux
  useEffect(() => {
    getDados();
    getAtrasados();
    getContagem();
  }, [getAtrasados, getContagem, getDados]);

  // Funçoes da pagina

  if (loading) {
    return <Load />;
  }

  async function handlerProximo() {
    // setLoading(true);
    const responseListagem = await api.get(
      `/atividade-realizar?page=${page + 1}`
    );
    const qtTotal = Number(responseListagem.data.total);

    if (dadosAndamento.length >= qtTotal) {
      setCarregarVisible(false);
    } else {
      const teste = [...dadosAndamento, ...responseListagem.data.data];

      setDadosAndamento(teste);

      if (teste.length >= qtTotal) {
        setCarregarVisible(false);
      } else {
        setCarregarVisible(true);
      }

      setPage(page + 1);
    }

    // setLoading(false);
  }

  async function handlerProximoAtrasado() {
    const responseAtrasado = await api.get(
      `/atividade-atrasado?page=${pageAtrasado + 1}`
    );
    const qtTotal = Number(responseAtrasado.data.total);

    if (dadosAndamento.length >= qtTotal) {
      setCarregarVisibleAtrasado(false);
    } else {
      const teste = [...dadosAtrasados, ...responseAtrasado.data.data];

      setDadosAtrasados(teste);

      if (teste.length >= qtTotal) {
        setCarregarVisibleAtrasado(false);
      } else {
        setCarregarVisibleAtrasado(true);
      }

      setPageAtrasado(pageAtrasado + 1);
    }
  }

  return (
    <Container>
      <Card>
        <InfoAtendimento>
          <TarefaDia>
            <h4>Tarefas</h4>
            <InfoTarefas>
              <Info>
                <h4>
                  <span>{countEmail}</span> E-mails
                </h4>
              </Info>
              <Info>
                <h4>
                  <span>{countTelefone}</span> Ligações
                </h4>
              </Info>
              <Info>
                <h4>
                  <span>{countWhatsapp}</span> Mensagens Whatsapp
                </h4>
              </Info>
              <Info danger>
                <h4>
                  <span>{countAtrasados}</span> Tarefas atrasadas
                </h4>
              </Info>
            </InfoTarefas>
          </TarefaDia>
        </InfoAtendimento>
        <Tarefas>
          <Dia>
            <h4>Tarefas do dia</h4>
            <BlocosDia>
              {dadosAndamento.map(dado => (
                <Bloco key={dado.id}>
                  <DadosPessoais>
                    <Dados>
                      <h4>{dado.lead.name}</h4>
                      <span>{dado.lead.telefone}</span>
                      <br />
                      <span>{dado.lead.user.time.name}</span>
                    </Dados>
                    <InfoTentativas>
                      <p>
                        <FaBuilding color="#EEE" size={18} />{' '}
                        {dado.lead.produto.name}
                      </p>
                      {dado?.lead?.canal === 'fb' && (
                        <p>
                          <FaFacebookSquare
                            color="#FFF"
                            size={20}
                            title="Origem: Facebook"
                          />{' '}
                          Facebook
                        </p>
                      )}
                      {dado?.lead?.canal === 'ig' && (
                        <p>
                          <FaInstagram
                            color="#FFF"
                            size={20}
                            title="Origem: Instagram"
                          />{' '}
                          Instagram
                        </p>
                      )}
                      {dado?.lead?.canal === 'bot' && (
                        <p>
                          <FaRobot
                            color="#FFF"
                            size={20}
                            title="Origem: ChatBot"
                          />{' '}
                          ChatBot
                        </p>
                      )}
                      {dado?.lead?.canal === 'cms' && (
                        <p>
                          <FaPenSquare
                            color="#FFF"
                            size={20}
                            title="Origem: CMS"
                          />{' '}
                          CMS
                        </p>
                      )}
                      {dado?.lead?.canal === 'lp' && (
                        <p>
                          <FaWindowMaximize
                            color="#FFF"
                            size={20}
                            title="Origem: Land Page"
                          />{' '}
                          Land Page
                        </p>
                      )}
                      {dado?.lead?.canal === 'st' && (
                        <p>
                          <FaWeebly
                            color="#FFF"
                            size={20}
                            title="Origem: Site"
                          />{' '}
                          Site
                        </p>
                      )}
                      {dado?.lead?.canal === 'ch' && (
                        <p>
                          <FaRocketchat
                            color="#FFF"
                            size={20}
                            title="Origem: Chat"
                          />{' '}
                          Chat
                        </p>
                      )}
                      {dado?.lead?.canal === 'mailing' && (
                        <p>
                          <IoMdMail
                            color="#FFF"
                            size={20}
                            title="Origem: Mailing"
                          />{' '}
                          Chat
                        </p>
                      )}
                      {dado?.lead?.canal === null && (
                        <p>
                          <FaTimes
                            color="#FFF"
                            size={20}
                            title="Origem: Sem canal"
                          />{' '}
                          Sem canal
                        </p>
                      )}
                    </InfoTentativas>
                  </DadosPessoais>
                  <DadosAtendimento>
                    <InfoTentativas>
                      <p>
                        <span>{dado.tentativa - 1}</span>&nbsp; Tentativas
                      </p>
                      {dado?.tentativaAtual?.tipo === 'E-mail' && (
                        <p>
                          <FaEnvelope color="#FFF" size={20} /> Enviar e-mail
                        </p>
                      )}
                      {dado?.tentativaAtual?.tipo === 'Telefone' && (
                        <p>
                          <FaPhoneVolume color="#FFF" size={20} /> Fazer ligação
                        </p>
                      )}
                      {dado?.tentativaAtual?.tipo === 'Whatsapp' && (
                        <p>
                          <FaWhatsapp color="#FFF" size={20} /> Enviar whatsapp
                        </p>
                      )}
                    </InfoTentativas>
                    <Link to={`/atendimento-create/${dado.id}`}>
                      <button type="button">Atender agora</button>
                    </Link>
                    <Atendimento>
                      <p>Próximo atendimento</p>
                      <p>{dado.dataFormated}</p>
                    </Atendimento>
                  </DadosAtendimento>
                </Bloco>
              ))}
            </BlocosDia>
            {carregarVisible && (
              <BtCarregar type="button" onClick={handlerProximo}>
                Carregar mais
              </BtCarregar>
            )}
          </Dia>
          <Atrasadas>
            <h4>Tarefas atrasadas</h4>
            <Blocos>
              {dadosAtrasados.map(dado => (
                <Bloco key={dado.id} atrasada>
                  <DadosPessoais>
                    <Dados>
                      <h4>{dado.lead.name}</h4>
                      <span>{dado.numeroFormatado}</span>
                      <br />
                      <span>{dado.lead.user.time.name}</span>
                    </Dados>
                    <InfoTentativas>
                      <p>
                        <FaBuilding color="#EEE" size={18} />{' '}
                        {dado.lead.produto.name}
                      </p>
                      {dado.lead.canal === 'fb' && (
                        <p>
                          <FaFacebookSquare
                            color="#FFF"
                            size={20}
                            title="Origem: Facebook"
                          />{' '}
                          Facebook
                        </p>
                      )}
                      {dado?.lead?.canal === 'ig' && (
                        <p>
                          <FaInstagram
                            color="#FFF"
                            size={20}
                            title="Origem: Instagram"
                          />{' '}
                          Instagram
                        </p>
                      )}
                      {dado?.lead?.canal === 'bot' && (
                        <p>
                          <FaRobot
                            color="#FFF"
                            size={20}
                            title="Origem: ChatBot"
                          />{' '}
                          ChatBot
                        </p>
                      )}
                      {dado?.lead?.canal === 'cms' && (
                        <p>
                          <FaPenSquare
                            color="#FFF"
                            size={20}
                            title="Origem: CMS"
                          />{' '}
                          CMS
                        </p>
                      )}
                      {dado?.lead?.canal === 'lp' && (
                        <p>
                          <FaWindowMaximize
                            color="#FFF"
                            size={20}
                            title="Origem: Land Page"
                          />{' '}
                          Land Page
                        </p>
                      )}
                      {dado?.lead?.canal === null && (
                        <p>
                          <FaTimes
                            color="#FFF"
                            size={20}
                            title="Origem: Sem canal"
                          />{' '}
                          Sem canal
                        </p>
                      )}
                    </InfoTentativas>
                  </DadosPessoais>
                  <DadosAtendimento>
                    <InfoTentativas>
                      <p>
                        <span>{dado.tentativa}</span>&nbsp; Tentativas
                      </p>
                      {dado?.tentativaAtual?.tipo === 'E-mail' && (
                        <p>
                          <FaEnvelope color="#FFF" size={20} /> Enviar e-mail
                        </p>
                      )}
                      {dado?.tentativaAtual?.tipo === 'Telefone' && (
                        <p>
                          <FaPhoneVolume color="#FFF" size={20} /> Fazer ligação
                        </p>
                      )}
                      {dado?.tentativaAtual?.tipo === 'Whatsapp' && (
                        <p>
                          <FaWhatsapp color="#FFF" size={20} /> Enviar whatsapp
                        </p>
                      )}
                    </InfoTentativas>
                    <Link to={`/atendimento-create/${dado.id}`}>
                      <button type="button">Atender agora</button>
                    </Link>
                    <Atendimento>
                      <p>Próximo atendimento</p>
                      <p>{dado.dataFormated}</p>
                    </Atendimento>
                  </DadosAtendimento>
                </Bloco>
              ))}
            </Blocos>
            {carregarVisibleAtrasado && (
              <BtCarregar type="button" onClick={handlerProximoAtrasado}>
                Carregar mais
              </BtCarregar>
            )}
          </Atrasadas>
        </Tarefas>
      </Card>
    </Container>
  );
}
